/**
 * EmployeeTerasuAnswerPage — 社員Web版（通常セッション）用の GBなび 回答フロー
 *
 * モバイルの GBなび回答（EmbeddedTerasuAnswerPage）と同じ TerasuAnswerFlow を、
 * ネイティブ token 注入ではなく通常の Cognito セッション（ProtectedRoute）で描画する。
 * 完了時はモバイルの notifyAnswerDone ではなくダッシュボードへ戻す。
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TerasuAnswerFlow } from '../terasu';

export const EmployeeTerasuAnswerPage: React.FC = () => {
  const navigate = useNavigate();
  return <TerasuAnswerFlow onComplete={() => navigate('/dashboard', { replace: true })} />;
};

export default EmployeeTerasuAnswerPage;
